import { ItemClass, ItemClasses } from '../../common/constants'
import { uniqueId } from '../../helpers/uniqueId'

export type CuratedTemplateAvailability = 'draft' | 'published'

export type CuratedTemplate = {
  curatedTemplateId: string
  name: string
  description: string
  availability: CuratedTemplateAvailability
  aiInstructions: string
  items: CuratedTemplateItem[]
  lastUpdatedAt: string
}

export type CuratedTemplateItem = {
  curatedTemplateItemId: string
  name: string
  nameAliases: string[]
  class: ItemClass
  units?: string
  cost?: number
  rateInstallationQuantity?: number
  ratePerUnits?: string
  rateUsageQuantity?: number
  sortIndex: number
}

export type CuratedTemplateUpsertRequest = Omit<CuratedTemplate, 'lastUpdatedAt'>

export type CuratedTemplateSummary = {
  curatedTemplateId: string
  name: string
  availability: CuratedTemplateAvailability
  lastUpdatedAt: string
}

export type CuratedTemplatesPage = {
  totalCount: number
  totalPages: number
  templates: CuratedTemplateSummary[]
}

export const createCuratedTemplateDraft = (): CuratedTemplate => ({
  curatedTemplateId: uniqueId(),
  name: '',
  description: '',
  availability: 'draft',
  aiInstructions: '',
  items: [],
  lastUpdatedAt: ''
})

export const createCuratedTemplateItem = (sortIndex: number): CuratedTemplateItem => ({
  curatedTemplateItemId: uniqueId(),
  name: '',
  nameAliases: [],
  class: ItemClasses.Materials,
  units: '',
  cost: undefined,
  rateInstallationQuantity: undefined,
  ratePerUnits: undefined,
  rateUsageQuantity: undefined,
  sortIndex
})

export const defaultCuratedTemplate = (): CuratedTemplate => ({
  curatedTemplateId: '00000000-0000-0000-0000-000000000000',
  name: 'Curated Template',
  description: '',
  availability: 'draft',
  aiInstructions: '',
  items: [],
  lastUpdatedAt: '2026-01-01T00:00:00Z'
})

export const defaultCuratedTemplateItem = (): CuratedTemplateItem => ({
  curatedTemplateItemId: '00000000-0000-0000-0000-000000000001',
  name: 'Item',
  nameAliases: [],
  class: ItemClasses.Materials,
  units: 'each',
  cost: 0,
  rateInstallationQuantity: undefined,
  ratePerUnits: undefined,
  rateUsageQuantity: undefined,
  sortIndex: 0
})
